import { InjectionToken } from '@angular/core';
import { LoaderOptions } from '@googlemaps/js-api-loader';
import { environment } from '../../../environments/environment';

export const DEFAULT_MAP_ID = '19bd4c993a57f389';

export const DEFAULT_MAP_OPTIONS: google.maps.MapOptions = {
  center: {
    lat: 39.8282172,
    lng: -98.5795122,
  },
  zoom: 4,
  heading: 0,
  maxZoom: 20,
  gestureHandling: 'greedy',
  disableDefaultUI: true,
  mapId: DEFAULT_MAP_ID,
};

export const GOOGLE_MAPS_LOADER_OPTIONS = new InjectionToken<LoaderOptions>(
  'GOOGLE_MAPS_LOADER_OPTIONS',
  {
    providedIn: 'root',
    factory: () => ({
      apiKey: environment.googleMapsApiKey,
      version: 'quarterly',
      libraries: ['geometry', 'marker'],
      mapIds: [DEFAULT_MAP_ID],
    }),
  },
);
